import { render } from "./GamesTable.vue?vue&type=template&id=601b150c&scoped=true"
import script from "./GamesTable.vue?vue&type=script&lang=js"
export * from "./GamesTable.vue?vue&type=script&lang=js"

import "./GamesTable.vue?vue&type=style&index=0&id=601b150c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-601b150c"]])

export default __exports__